module["exports"] = [
  "Південний",
  "Північний",
  "Східний",
  "Західний"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/city_prefix.js
// module id = 1799
// module chunks = 1